<template>
  <div>
    <div class="row no-gutters">
      <div class="col-md-12">
        <KTCodePreview v-bind:title="'Master Kenaikan Pangkat'">
          <template v-slot:body>
            <v-row style="margin-top: 20px; margin-bottom: 20px;">
              <div class="row">
                <div class="col-6 pb-0">
                  <b-form-group label-cols="4" label-cols-lg="4" label="Angkatan">
                    <Select2 v-model="filter.angkatan" :options="angkatan" @change="SelectFilter($event)" />
                  </b-form-group>
                </div>
                <div class="col-6 pb-0" v-if="stgProdi == null">
                  <b-form-group label-cols="4" label-cols-lg="4" label="Program Studi">
                    <Select2 v-model="filter.prodi" :options="prodiOptions" @change="SelectFilter($event)" />
                  </b-form-group>
                </div>
                <div class="col-3 offset-9 d-flex justify-content-end">
                  <b-button class="button-colors mr-4" @click="openModal('Ubah')">
                    <span style="display: contents;"><span class="text px-4">Ubah Pangkat </span></span>
                  </b-button>
                </div>
              </div>
            </v-row>
            <v-card>
              <v-card-title>
                <!-- <ButtonComponent colors="linear-gradient(90deg, #21AE95 0%, #21AE95 0.01%, #5CCCB8 71.72%)" name="tanpaicon" Title="Ubah Tingkat" @click.native="openModal('Ubah')"></ButtonComponent> -->
                <v-spacer></v-spacer>
                <v-text-field v-model="search" label="Search" single-line hide-details></v-text-field>
              </v-card-title>
              <!-- <v-data-table :headers="headers" :items="data" :search="search" show-select v-model="data_import" :item-key="itemKey" :selected="selectedKey"> -->
              <v-data-table :headers="headers" :items="data" :search="search">
                <template v-slot:item.no="{ item }">
                  {{ item.no }}.
                </template>
                <template v-slot:item.action="{ item }">
                  <ButtonComponent colors="#3751E4" name="edit" @click.native="openModal('Edit', item)"
                    dataTitleTooltip="Edit" />
                </template>
              </v-data-table>
            </v-card>
          </template>
        </KTCodePreview>


        <b-modal @ok="onSubmit" ok-title="Simpan" ok-variant="primary" no-enforce-focus cancel-title="Batal"
          cancel-variant="danger" id="modal" :title="`Kenaikan Pangkat`" ref="modal">
          <b-form>
            <!-- pangkat -->
            <div class="row" style="padding-top: 10px; margin-bottom: 10px">
              <div class="col-lg-6" style="padding-left: 25px;">
                <div class="row">
                  Status Pangkat Saat Ini
                </div>
                <div class="row" style="padding-top: 5px;">
                  {{ show.pangkat }}
                </div>
              </div>
              <div class="col-lg-6" style="padding-left: 25px;">
                <div class="row">
                  Status Tingkat Saat Ini
                </div>
                <div class="row" style="padding-top: 5px;">
                  {{ show.tingkat }}
                </div>
              </div>
              <div class="col-lg-12"
                style="border-top: 1px solid; padding: 0px; border-top: 1px solid; height: 1px; margin-top: 10px;"></div>
              <div class="col-lg-6">
                <b-form-group label="Status Kenaikan Pangkat">
                  <Select2 v-model="request.status_pangkat" @change="changeStatusPangkat($event)" :options="statusPangkat"
                    :settings="{ settingOption: value, multiple: false, width: '100%' }"
                    :placeholder="`Pilih Status Kenaikan Pangkat`" />
                </b-form-group>
                <b-form-group label="Tanggal Pengesahan Pangkat" v-if="showSelectPangkat != null"
                  label-for="input-default">
                  <b-form-input v-model="request.tanggal_pangkat" id="input-default" type="date"></b-form-input>
                </b-form-group>
              </div>
              <div class="col-lg-6">
                <b-form-group label="Pangkat" v-if="showSelectPangkat === '1'">
                  <b-form-input v-model="request.pangkat_name" readonly></b-form-input>
                </b-form-group>
                <b-form-group label="Alasan" v-else-if="showSelectPangkat === '2'">
                  <b-form-textarea v-model="request.alasan_pangkat" rows="3" no-resize
                    placeholder="Masukkan Alasan"></b-form-textarea>
                </b-form-group>
              </div>
            </div>
          </b-form>
        </b-modal>

        <!-- Modal Update Massal -->
        <b-modal @ok="postDataToAPI" @cancel="cancelDataMassal" no-enforce-focus ok-title="Simpan" size="lg"
          ok-variant="primary" cancel-title="Batal" cancel-variant="danger" id="modalcheckall" ref="modalcheckall"
          :title="`Kenaikan Pangkat`">
          <b-form>
            <div class="row no-gutters">
              <div class="col-lg-12" style="margin-top: auto; margin-bottom: auto;">
                <SelectComponent v-model="request.program" :statusInline="'4'" Title="Program Studi"  :data="prodiOptions" :changeSelected="changeProgram"
                  :models="request.program"></SelectComponent>

                <SelectComponent v-model="request.angkatan" :statusInline="'4'" Title="Angkatan"  :data="angkatan" :changeSelected="changeAngkatan"
                  :models="request.angkatan">
                </SelectComponent>

                <SelectComponent v-model="request.kelas" :statusInline="'4'" Title="Kelas"  :data="groups" :changeSelected="changeKelas"
                  :models="request.kelas">
                </SelectComponent>
                <div v-if="data_import.length != 0" class="row">
                  <div class="col-lg-12">
                    <p class="font-weight-bold" style="margin-bottom: 3px;">Data Taruna</p>
                    <v-data-table :headers="header_modal" :items="data_import" hide-default-footer disable-pagination show-select v-model="request.course" :item-key="itemKey" :selected="selectedKey" 
                        @input="checkSameRankSelected"></v-data-table>
                  </div>
                  <div class="col-6">
                    <b-form-group label="Status Kenaikan Pangkat">
                      <Select2 v-model="request.status_pangkat" @change="changeStatusPangkatMassal($event)" :options="statusPangkat"
                        :settings="{ settingOption: value, multiple: false, width: '100%' }"
                        :placeholder="`Pilih Status Kenaikan Pangkat`" />
                      </b-form-group>
                    <b-form-group label="Tanggal Pengesahan Pangkat" v-if="showSelectPangkat != null"
                      label-for="input-default">
                      <b-form-input v-model="request.tanggal_pangkat" id="input-default" type="date"></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-lg-6">
                    <b-form-group label="Pangkat" v-if="showSelectPangkat === '1'">
                      <b-form-input v-model="request.pangkat_name" readonly></b-form-input>
                    </b-form-group>
                    <b-form-group label="Alasan" v-else-if="showSelectPangkat === '2'">
                      <b-form-textarea v-model="request.alasan_pangkat" rows="3" no-resize
                        placeholder="Masukkan Alasan"></b-form-textarea>
                    </b-form-group>
                  </div>
                </div>
              </div>
            </div>
          </b-form>
        </b-modal>

      </div>
    </div>
  </div>
</template>

<script>
import KTCodePreview from "@/view/content/CardContent.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ButtonComponent from "@/view/content/components/button/buttonComponent.vue";
import SelectComponent from "@/view/content/components/select/SelectComponent.vue";
import Select2 from 'v-select2-component';
import axios from "axios";

export default {
  data() {
    return {
      data: [],
      showSelectPangkat: null,
      showSelectTingkat: null,
      disabledPangkat: false,
      disabledTingkat: false,
      statusTingkat: [
        { id: null, text: "--Pilih Status--" },
        { id: "1", text: "Naik" },
        { id: "2", text: "Tetap" }
      ],
      statusPangkat: [
        { id: null, text: "--Pilih Status--" },
        { id: 1, text: "Naik" },
        { id: 2, text: "Tetap" }
      ],
      masterTingkat: [
        { id: "Tingkat I", text: "Tingkat I" },
        { id: "Tingkat II", text: "Tingkat II" },
        { id: "Tingkat III", text: "Tingkat III" },
        { id: "Tingkat IV", text: "Tingkat IV" }
      ],
      optTingkat: [],
      optTingkatMassal: [],
      statusModal: '',
      // dataAgama: [],
      dataPromotion: [],
      promotionStudent: [],
      statusStudent: "",
      search: "",
      selectedProdi: 0,
      selectedJadwal: 0,
      prodiOptions: [
        { id: null, text: '--Pilih Prodi--' },
      ],
      jadwalOptions: [
        { id: null, text: '--Pilih Jadwal--' },
      ],
      request: {
        key: null,
        key_student: null,
        nim: null,
        student_name: null,
        tahun_akademik: null,
        prodi: null,
        nama_pangkat: null,
        tingkat: null,
        religion_name: null,
        tanggal_tingkat: null,
        tanggal_pangkat: null,
        alasan_tingkat: null,
        alasan_pangkat: null,
        pangkat: null,
        pangkat_name: null,
        status_tingkat: null,
        status_pangkat: null,
        uni: 'Akademi Angkatan Laut',
        faculty: '1039706c-1b4c-4747-a5c0-88a8c0e78baa',
        department: null,
        angkatan: null,
        program: null,
        kelas: null,
        checkAll: null
      },
      pangkat: [],
      id_tetap: {
        pangkat: null,
        tingkat: null
      },
      status_isi: null,
      status_isi_tingkat: null,
      angkatan: [],
      data_import: [],
      department: [
      ],
      program: [
      ],
      groups: [],
      angkatan_massal: [],
      filter: {
        prodi: null,
        prodi_name: null,
        angkatan: null,
        angkatan_name: null
      },
      headers: [
        { text: "No", align: "left", value: "no" },
        { text: "NAK", align: "left", value: "nim" },
        { text: "Nama", align: "left", value: "student_name" },
        { text: "Prodi", value: "prodi" },
        { text: "Angkatan", value: "angkatan" },
        { text: "Kelas", value: "kelas" },
        { text: "Pangkat", value: "nama_pangkat" },
        { text: "Tingkat", value: "tingkat" },
        { text: "Aksi", align: "left", value: "action" }
      ],
      show: {
        pangkat: null,
        tingkat: null
      },
      stgProdi: null,
      itemKey: 'key',
      selectedKey: 'key',
      header_modal: [
        { text: "No", align: "left", value: "no" },
        { text: "NAK", align: "left", value: "nim" },
        { text: "Nama", align: "left", value: "student_name" },
        { text: "Tingkat", align: "left", value: "tingkat" },
        { text: "Pangkat", align: "left", value: "nama_pangkat" },
        // { text: "Kelas", align: "left", value: "kelas" },
        // { text: "Angkatan", align: "left", value: "angkatan" },
      ]
    };
  },
  components: {
    KTCodePreview,
    ButtonComponent,
    Select2,
    SelectComponent
  },

  computed: {
    itemsWithIndex() {
      return this.dataPromotion.map(
        (dataPromotion, index) => ({
          ...dataPromotion,
          no: index + 1
        }))
    }
  },
  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Master" },
      { title: "Kenaikan Pangkat" }
    ]);

    this.stgProdi = JSON.parse(localStorage.getItem('dataLogin')).key_prodi;
    await this.getData();
    await this.loadData();

  },
  methods: {
    async loadData(){
      const data1 = this.getProdi();
      const data2 = this.getJadwal()
      const data3 = this.getPangkat()
      const data4 = this.getDataDepartment()
      const data5 = this.getDataAngkatan();
      const data6 = this.getDataProgram();
      const data7 = this.getDataGroup();

      await Promise.all([data1,data2,data3,data4,data5,data6,data7]);
    },
    onChangeActive() {
      alert("Tes")
    },
    async postDataToAPI() {
      try {
        if (this.data_import.length === 0) {
          this.$swal(`Failed`);
        }
          this.request.course.map(async (row, index) => {

          // const detail_result = await axios.get(`master/promotion/${row.key}/student`);
          let old_pangkat = (this.showSelectPangkat === '1') ? this.request.pangkat : row.pangkat;
          let old_tingkat = (this.showSelectPangkat === '1') ? this.request.tingkat : row.tingkat;
          
          // if (this.request.tingkat == null) {
          //   if (detail_result.data.data.length > 0) {
          //     old_tingkat = detail_result.data.data.tingkat;
          //   }
          // }else{
          //   old_tingkat = this.request.tingkat;
          // }
          // if (this.request.pangkat == null) {
          //   if (detail_result.data.data.length > 0) {
          //     old_pangkat = detail_result.data.data.nama_pangkat;
          //   }
          // }else{
          //   old_pangkat = this.request.pangkat;
          // }
          const formData = {
            id_student: row.key,
            status_tingkat: this.request.status_tingkat,
            status_pangkat: this.request.status_pangkat,
            alasan_tingkat: this.request.alasan_tingkat,
            alasan_pangkat: this.request.alasan_pangkat,
            tingkat: old_tingkat,
            pangkat: old_pangkat,
            tanggal_tingkat: this.request.tanggal_tingkat,
            tanggal_pangkat: this.request.tanggal_pangkat,
          };
          // await axios.post(`master/promotion/${row.key}`, formData)
          const masterData =  await axios.post(`master/promotion/save`, formData)
          if (index >= this.request.course.length-1) {
            if (masterData.data.meta.code == 200) {
              this.$swal({
                title: 'Berhasil Kenaikan Data',
                icon: 'success', // You can use 'success', 'error', 'warning', etc.
                confirmButtonText: 'OK',
              }).then((result) => {
                if (result.isConfirmed) {
                  this.getData()
                }
              });
            }else{
              this.$swal(masterData.data.meta.message)
            }
          }
        });

        // await Promise.all(masterData);

      } catch (error) {
        await this.$swal('Failed :' + `${error.message}`);
      }
    },
    changeDepartment: function (selected) {
      this.request.department = selected;
      this.request.program = null;
      this.program.splice(0)
      this.getDataProgram()
      this.getDataGroup()
    },
    changeProgram: function (selected) {
      this.request.program = selected;
      this.request.angkatan = null;
      this.request.kelas = null;
      this.getDataGroup()
    },
    async changeKelas(selected) {
      this.request.kelas = selected;
      const result = await axios.get(`/master/student/promotion/filter-angkatan?angkatan=${this.request.angkatan}&prodi=${this.request.program}&group_key=${this.request.kelas}`);
      this.data_import = []
      
      result.data.data.map(async (e, index) => {

        const obj = {
          key: e.key,
          pangkat: e.key_pangkat,
          no: index + 1,
          nim: e.nim,
          student_name: e.student_name,
          prodi: e.prodi,
          angkatan: e.angkatan,
          nama_pangkat: e.nama_pangkat,
          tingkat: e.tingkat,
          kelas: e.nama_kelompok,
        };
        if (index >= result.data.data.length - 1) {
          // this.request.key_student = e.key
          this.request.tingkat = e.tingkat
        }
        this.data_import.push(obj);

      });
      this.optTingkatMassal = []
      let master = [{ id: "Tingkat I", text: "Tingkat I" }, { id: "Tingkat II", text: "Tingkat II" }, { id: "Tingkat III", text: "Tingkat III" }, { id: "Tingkat IV", text: "Tingkat IV" }]
      this.optTingkatMassal = master
      
    },
    changeAngkatan: function (selected) {
      this.request.angkatan = selected;
      this.request.kelas = null;
    },
    async getDataDepartment() {
      let link_api_department = "master/department/" + this.request.faculty + "/faculty"
      try {
        await axios.get(link_api_department)
          .then(response => {
            if (response.status == 200) {
              const filteredData = response.data.data.filter(item => item.department_code !== "NON-PRODI");
              filteredData.some((e, index) => {
                var object = { "id": e.key, "text": e.department_name }
                this.department.push(object);
                return index > e.length;
              });
            }
          })
      } catch (err) {
        // this.$swal(`Failed`);
      }
    },
    async getDataProgram() {
      let link_api_program = "master/study-program/" + this.request.department + "/dept"
      try {
        await axios.get(link_api_program)
          .then(response => {
            if (response.status == 200) {
              response.data.data.some((e, index) => {
                var object = { "id": e.key, "text": e.program_name }
                this.program.push(object);
                return index > e.length;
              });
            }
          })
      } catch (err) {
        // this.$swal(`Failed`);
      }
    },

    async getDataGroup() {
      try {
        this.groups = [];
        await axios.get(`master/student-group`)
          .then(response => {
            if (response.status == 200) {
              response.data.data.some((e, index) => {
                if (e.prodi_id == this.request.program) {
                  var object = { "id": e.key, "text": e.nama_kelompok }
                  this.groups.push(object);
                  return index > e.length;
                }
              });
            }
          })
      } catch (err) {
        // this.$swal(`Failed`);
      }
    },
    async cancelDataMassal() {
      this.request = {
        status_tingkat: null,
        status_pangkat: null,
        alasan_tingkat: null,
        alasan_pangkat: null,
        tingkat: null,
        pangkat: null,
        tanggal_tingkat: null,
        tanggal_pangkat: null,
      }

      this.showSelectPangkat = null
      this.showSelectTingkat = null
      this.data_import = [];
    },

    prodiFilter(value) {
      if (!this.prodiFilterValue) {
        return true;
      }
      return value === this.prodiFilterValue;
    },
    async getProdi() {
      await axios.get("master/study-programs")
        .then((response) => {
          if (response.status == 200) {
            const filteredData = response.data.data.filter(item => item.program_code !== "N001");
            filteredData.some((e, index) => {
              let object = { "id": e.key, "text": e.program_name }
              if (e.status) {
                this.prodiOptions.push(object);
              }
              return index > e.length;
            });
          }
        });
    },
    async getJadwal() {
      await axios.get('master/generations?status=true')
        .then(response => {
          response.data.data.map((e, index) => {
            let object = { "id": e.key, "text": `${e.tahun} ${e.tahun_akhir} / (${e.semester})` }
            this.jadwalOptions.push(object);
            return index > e.length;
          });
        });
    },
    async getPangkat() {
      this.pangkat = [];
      await axios.get("master/rank")
        .then((response) => {
          if (response.status == 200) {
            let filteredData;
            if (this.status_isi != null) {
              filteredData = response.data.data.filter(item => item.kategori == "SISWA" && item.urutan < this.status_isi).sort((a, b) => b.urutan - a.urutan);
            } else {
              filteredData = response.data.data.filter(item => item.kategori == "SISWA").sort((a, b) => b.urutan - a.urutan);
            }
            filteredData.map((e, index) => {

              var object = { "text": e.rank, "id": e.key }
              this.pangkat.push(object);
              return index > e.length;
            });
          }
        });
    },

    async getDataAngkatan() {
      const response = await axios.get('master/angkatan')
      if (response.status == 200) {
        response.data.data.map((e, index) => {
          if (e.status == true) {
            var object = { id: e.nama_angkatan, text: e.nama_angkatan }
            // var object = { id: e.key, text: e.nama_angkatan }
            // var object = { "id": e.key, "text": e.tahun + " " + e.semester }
            this.angkatan.push(object);
          }
          return index > e.length;
        });
      }
      this.sortedDes();
    },
    sortedDes() {
      return this.angkatan.sort((a, b) => {
        if (a.id && b.id) {
          if (parseInt(b.text) < parseInt(a.text)) return -1;
          if (parseInt(b.text) > parseInt(a.text)) return 1;
          return 0;
        }
      });
    },

    changePangkat: function (selected) {
      this.request.pangkat = selected;
    },
    async changeStatusPangkat(selected) {
      // this.showSelectPangkat = !this.showSelectPangkat;
      try {
        if (selected == '1') {
          const result = await axios.get(`master/promotion/get-next-pangkat/${this.request.key_student}`);
          
          // if (result.data.data) {
            this.request.pangkat = result.data.data.uuid;
            this.request.pangkat_name = result.data.data.nama_pangkat;
            
            // this.request.tingkat = result.data.data.nama_pangkat
            // }
        }
        this.showSelectPangkat = selected;
        this.disabledPangkat = true;
      } catch (error) {
        this.$swal('Failed');
      }
    },
    async changeStatusPangkatMassal(selected) {
      // this.showSelectPangkat = !this.showSelectPangkat;
      try {
        if (selected == '1') {
          const result = await axios.get(`master/promotion/get-next-pangkat/${this.request.key_student}`);
          // Di sini, Anda menunggu hingga permintaan API selesai sebelum mengubah state
          if (result.data.data) {
            this.request.pangkat = result.data.data.uuid;
            this.request.pangkat_name = result.data.data.nama_pangkat;
          }
        }
        this.showSelectPangkat = selected;
        this.disabledPangkat = true;
          // Pastikan state telah diperbarui dengan benar setelah permintaan selesai
      } catch (error) {
        // Tangani kesalahan jika terjadi saat melakukan permintaan API
        this.$swal('Failed');
      }
    },
    async changeStatusTingkat(selected) {
      // this.showSelectTingkat = !this.showSelectTingkat;
      this.showSelectTingkat = selected;
      this.disabledTingkat = true;
      if (selected == 1) {
        let tingkats = await axios.get(`master/promotion/get-next-tingkat/${this.request.key_student}`);
        var ting = this.masterTingkat.findIndex((tng)=>{return tng.id == tingkats.data.data});
        this.request.tingkat = this.masterTingkat[ting].text;
      }
    },
    async changeProdi(selected) {
      this.selectedProdi = selected;

      if (this.selectedJadwal) {
        await this.getData()
      }
    },

    async changeJadwal(selected) {
      this.selectedJadwal = selected

      if (this.selectedProdi) {
        await this.getData()
      }
    },

    async openModal(status, itemData = null) {
      this.statusModal = status
      this.showSelectPangkat = null;
      this.showSelectTingkat = null;
      this.showSelectPangkat = null
      this.showSelectTingkat = null
      this.data_import = []
      if (itemData === null) {
        this.$refs['modalcheckall'].show()
        this.request = {
          key_student: null,
          status_tingkat: null,
          status_pangkat: null,
          alasan_tingkat: null,
          alasan_pangkat: null,
          tingkat: null,
          pangkat: null,
          tanggal_tingkat: null,
          tanggal_pangkat: null,
          program: null,
          kelas: null,
          angkatan: null
        }
      }else{
        this.$refs['modal'].show()
        this.request = {
          key_student: itemData.key,
          status_tingkat: null,
          status_pangkat: null,
          alasan_tingkat: null,
          alasan_pangkat: null,
          tingkat: itemData.tingkat,
          pangkat: null,
          tanggal_tingkat: null,
          tanggal_pangkat: null,
          program: null,
          kelas: null,
          angkatan: null
        }
        this.optTingkat = []
        let master = [{ id: "Tingkat I", text: "Tingkat I" }, { id: "Tingkat II", text: "Tingkat II" }, { id: "Tingkat III", text: "Tingkat III" }, { id: "Tingkat IV", text: "Tingkat IV" }]
        this.getPangkat()
        const result = await axios.get(`master/promotion/${itemData.key}/student`);
        if (result.data.data == null) {
          // reset form
          this.show.pangkat = (itemData.nama_pangkat)? itemData.nama_pangkat : "-";
          this.show.tingkat = (itemData.tingkat)? itemData.tingkat : "-";
          this.optTingkat = master
        } else {
          // const ranked = await axios.get(`master/rank/${result.data.data[0].pangkat}/detail`);
          this.show.pangkat = (result.data.data.nama_pangkat) ? result.data.data.nama_pangkat : '-'
          this.show.tingkat = (result.data.data.tingkat) ? result.data.data.tingkat : '-'
          let id_pangkat = result.data.data.pangkat
          this.id_tetap.pangkat = result.data.data.key_pangkat
          this.id_tetap.tingkat = result.data.data.tingkat
          this.optTingkat = master
          let jumlah = this.optTingkat.findIndex(x => x.id === this.show.tingkat);
          jumlah++
          this.optTingkat.splice(0, jumlah)
          let jumlahpangkat = this.pangkat.findIndex(a => a.id === id_pangkat)
          jumlahpangkat++
          this.pangkat.splice(0, jumlahpangkat)
        }
      }
    },

    async getData() {
      let result = '';
      if (this.stgProdi) {
        result = await axios.get(`master/student/promotion/filter-angkatan?prodi=${this.stgProdi}`);
      }else {
        result = await axios.get(`master/student/promotion/filter-angkatan`);
      }
      this.dataPromotion = result.data.data;
      this.data = []
      result.data.data.map((e, index) => {
        var obj = {
          key: e.key,
          no: index + 1,
          nim: e.nim,
          student_name: e.student_name,
          prodi: e.prodi,
          angkatan: e.angkatan,
          nama_pangkat: e.nama_pangkat,
          tingkat: e.tingkat,
          kelas: e.nama_kelompok,
        };
        this.data.push(obj);

        return e.length > index;
      });
    },
    async SelectFilter() {
      if (this.filter.angkatan !== null && this.filter.prodi !== null) {
        try {
          const result = await axios.get(`/master/student/promotion/filter-angkatan?angkatan=${this.filter.angkatan}&prodi=${this.filter.prodi}`);
          this.dataPromotion = result.data.data;
          this.data = []
          result.data.data.map((e, index) => {
            var obj = {
              key: e.key,
              keyPangkat: e.key_pangkat,
              no: index + 1,
              nim: e.nim,
              student_name: e.student_name,
              prodi: e.prodi,
              angkatan: e.angkatan,
              nama_pangkat: e.nama_pangkat,
              tingkat: e.tingkat,
              kelas: e.nama_kelompok,
            };
            this.data.push(obj);

            return e.length > index;
          });
        } catch (err) {
          // this.$swal(`Failed`);
        }
      }
      else if (this.filter.angkatan !== null) {
        try {
          const result = await axios.get(`/master/student/promotion/filter-angkatan?angkatan=${this.filter.angkatan}`);
          this.dataPromotion = result.data.data;
          this.data = []
          result.data.data.map((e, index) => {
            var obj = {
              key: e.key,
              keyPangkat: e.key_pangkat,
              no: index + 1,
              nim: e.nim,
              student_name: e.student_name,
              prodi: e.prodi,
              angkatan: e.angkatan,
              nama_pangkat: e.nama_pangkat,
              tingkat: e.tingkat,
              kelas: e.nama_kelompok,
            };
            this.data.push(obj);

            return e.length > index;
          });
        } catch (err) {
          // this.$swal(`Failed`);
        }
      }
      else if (this.filter.prodi !== null) {
        try {
          const result = await axios.get(`/master/student/promotion/filter-angkatan?prodi=${this.filter.prodi}`);
          this.dataPromotion = result.data.data;
          this.data = []
          result.data.data.map((e, index) => {
            var obj = {
              key: e.key,
              keyPangkat: e.key_pangkat,
              no: index + 1,
              nim: e.nim,
              student_name: e.student_name,
              prodi: e.prodi,
              angkatan: e.angkatan,
              nama_pangkat: e.nama_pangkat,
              tingkat: e.tingkat,
              kelas: e.nama_kelompok,
            };
            this.data.push(obj);

            return e.length > index;
          });
        } catch (err) {
          // this.$swal(`Failed`);
        }
      }
    },
    async getDataStudent(student_key) {

      const result = await axios.get(`master/promotion/${student_key}/student`);

      this.promotionStudent = result.data.data;

    },

    async onSubmit() {
      const form = this.request
      if (form.pangkat == null) {
        form.pangkat = this.id_tetap.pangkat
      }
      if (form.tingkat == null) {
        form.tingkat = this.id_tetap.tingkat
      }
      this.update(form)
    },

    async update(form) {
      try {
        var formData = {
          id_student: form.key_student,
          status_tingkat: form.status_tingkat,
          status_pangkat: form.status_pangkat,
          alasan_tingkat: form.alasan_tingkat,
          alasan_pangkat: form.alasan_pangkat,
          tingkat: form.tingkat,
          pangkat: form.pangkat,
          tanggal_tingkat: form.tanggal_tingkat,
          tanggal_pangkat: form.tanggal_pangkat,
        };
        
        const result = await axios.post(`master/promotion/save`, formData)
        if (result.data.meta.code == 100) {
          this.$refs['modal'].show()
          this.$swal(result.data.meta.message);
        }else{
          this.refreshData(result, 'Store')
        }
        // this.refreshData(result, 'Update')

      } catch (err) {
        this.$swal(`Failed Add Data`);
        this.getData()
      }
    },

    refreshData(result, alert) {
      if (result.data.meta.code == 200) {
        this.$swal(`Success ${alert} Data`);
        this.getData()
      } else if (result.data.meta.code == 409) {
        this.$swal(`Failed, Data Already Exist!`);
        this.getData()
      } else if (result.data.meta.code == 100) {
        this.$refs['modal'].show()
        this.$swal(result.data.meta.message);
      } else if (result.data.meta.code == 400) {
        this.$swal(result.data.meta.message);
      } else {
        this.$swal(`Failed ${alert} Data`);
      }
    },
    // Fungsi untuk memeriksa apakah semua user yang dipilih memiliki pangkat yang sama
    checkSameRankSelected() {
      const selectedRanks = new Set(); // Set untuk menyimpan pangkat yang dipilih
      let courses = [];
      // Lakukan pengecekan untuk setiap item yang dipilih
      this.request.course.forEach(item => {
        // Tambahkan pangkat dari item yang dipilih ke dalam Set
        this.request.key_student = item.key
        // if(this.request.pangkat != null){
          // }
          selectedRanks.add(item.nama_pangkat);
          courses.push(item.nama_pangkat)
        });
        if (courses.length < 1) {
          this.request.pangkat = null;
          this.request.pangkat_name = null;
          this.request.key_student = null;
          this.request.status_pangkat = null;
          this.showSelectPangkat = null;
        }
        // if (this.request.key_student && selectedRanks.size == 1) {
        //   this.changeStatusPangkatMassal(this.showSelectPangkat);
        // }
      // Jika jumlah elemen dalam Set lebih dari 1, artinya ada lebih dari satu pangkat yang dipilih
      if (selectedRanks.size > 1) {
        // Tampilkan pesan kesalahan kepada pengguna
        this.$swal('Mohon pilih user dengan pangkat yang sama.');
        // Hilangkan seleksi yang tidak sesuai
        this.request.course.pop()
        // this.request.course = this.request.course.filter(item => item.nama_pangkat === selectedRanks.has(item.nama_pangkat));
      }
    },
  },
}
</script>

<style scoped>
.button-colors{
    border-radius: 5px;
    background: linear-gradient(90deg, #21AE95 0%, #21AE95 0.01%, #5CCCB8 71.72%);
    color: white;
}
</style>